export class WebTmsCatResponce {
    constructor(WebCngTmsCatPk = '', WebCngTmsCatId = '', WebCngTmsCatNm = '', WebCngTmsFormPk = '', WebCngTmsFormAttr = []) {
        this.pk = WebCngTmsCatPk;
        this.id = WebCngTmsCatId;
        this.name = WebCngTmsCatNm;
        this.WebCngTmsFormPk = WebCngTmsFormPk;
        this.WebCngTmsFormAttr = WebCngTmsFormAttr.map((item) => new WebCngTmsFormAttrForm(item.Id, item.No, item.Nm, item.Type, item.Choices, item.Required, item.Explain));
    }

    static formApiResponse(data) {
        return new WebTmsCatResponce(data.WebCngTmsCatPk, data.WebCngTmsCatId, data.WebCngTmsCatNm, data.WebCngTmsFormPk, data.WebCngTmsFormAttr);
    }
}

export class WebArmIsuResponce {
    constructor(IssuePk = '', IssueId = '', IssueNm = '') {
        this.pk = IssuePk;
        this.id = IssueId;
        this.name = IssueNm;
    }

    static formApiResponse(data) {
        return new WebArmIsuResponce(data.IssuePk, data.IssueId, data.IssueNm);
    }
}

export class WebCngTmsFormAttrForm {
    constructor(Id = '', No = 0, Nm = '', Type = '', Choices = [], Required = true, Explain = '') {
        this.Id = Id;
        this.No = No;
        this.Nm = Nm;
        this.Type = Type;
        this.Choices = Choices;
        this.Required = Required;
        this.Explain = Explain;
    }
}

export class WebCngTmsFormDataForm {
    constructor(Id = '', Values = []) {
        this.Id = Id;
        this.Values = Values;
    }
}

// 予約詳細レスポンス
export class WebdtlResponce {
    constructor(
        WebCngStatus = '',
        QuestionStatus = '',
        WebCngOpenDt = '',
        WebCngCloseDt = '',
        NoticeHistPk = '',
        WebCngArmSubj = '',
        WebCngArmIsuPk = '',
        WebCngArmIsuNm = '',
        WebCngArmCont = '',
        WebCngTmsCat1Pk = '',
        WebCngTmsCat1Nm = '',
        WebCngTmsCat2Pk = '',
        WebCngTmsCat2Nm = '',
        WebCngTmsCat3Pk = '',
        WebCngTmsCat3Nm = '',
        WebCngTmsFormPk = '',
        WebCngTmsFormAttr = [],
        WebCngTmsFormData = []
    ) {
        this.WebCngStatus = WebCngStatus;
        this.QuestionStatus = QuestionStatus;
        this.WebCngOpenDt = WebCngOpenDt;
        this.WebCngCloseDt = WebCngCloseDt;
        this.NoticeHistPk = NoticeHistPk;
        this.WebCngArmSubj = WebCngArmSubj;
        this.WebCngArmIsuPk = WebCngArmIsuPk;
        this.WebCngArmIsuNm = WebCngArmIsuNm;
        this.WebCngArmCont = WebCngArmCont;
        this.WebCngTmsCat1Pk = WebCngTmsCat1Pk;
        this.WebCngTmsCat1Nm = WebCngTmsCat1Nm;
        this.WebCngTmsCat2Pk = WebCngTmsCat2Pk;
        this.WebCngTmsCat2Nm = WebCngTmsCat2Nm;
        this.WebCngTmsCat3Pk = WebCngTmsCat3Pk;
        this.WebCngTmsCat3Nm = WebCngTmsCat3Nm;
        this.WebCngTmsFormPk = WebCngTmsFormPk;
        this.WebCngTmsFormAttr = WebCngTmsFormAttr.map((item) => new WebCngTmsFormAttrForm(item.Id, item.No, item.Nm, item.Type, item.Choices, item.Required, item.Explain));
        this.WebCngTmsFormData = WebCngTmsFormData.map((item) => new WebCngTmsFormDataForm(item.Id, item.Values));
    }
}
